var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        maskClosable: false,
        confirmLoading: _vm.confirmLoading,
        cancelText: _vm.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form",
            { attrs: { form: _vm.form } },
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.language["tbasedataconfig.configName"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["configName", _vm.validatorRules.configName],
                        expression: "[ 'configName', validatorRules.configName]"
                      }
                    ],
                    attrs: {
                      placeholder: _vm.language["tbasedataconfig.configNamePh"]
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.language["tbasedataconfig.configKey"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["configKey", _vm.validatorRules.configKey],
                        expression: "[ 'configKey', validatorRules.configKey]"
                      }
                    ]
                  })
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.language["tbasedataconfig.configValue"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["configValue", _vm.validatorRules.configValue],
                        expression:
                          "[ 'configValue', validatorRules.configValue]"
                      }
                    ]
                  })
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.language["tbasedataconfig.configType"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("j-dict-select-tag", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["configType", _vm.validatorRules.configType],
                        expression: "['configType', validatorRules.configType]"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      "trigger-change": true,
                      dictCode: "config_type"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.language["tbasedataconfig.remark"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["remark", _vm.validatorRules.remark],
                        expression: "[ 'remark', validatorRules.remark]"
                      }
                    ]
                  })
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.language["tbasedataconfig.activeFlag"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("j-dict-select-tag", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["activeFlag", _vm.validatorRules.activeFlag],
                        expression: "['activeFlag', validatorRules.activeFlag]"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      "trigger-change": true,
                      dictCode: "active_flag"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }